import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop-utils/entry-points/ApolloErrorInterop.ts';
import React from 'react';

import { PageViewRestrictions } from './PageViewRestrictions.tsx';
import { SpaceRestrictionCheck } from './SpaceRestrictionCheck.tsx';

type RestrictionsCheckProps = {
	children: (result: {
		error: ApolloErrorInterop | undefined;
		hasDirectViewRestrictions: boolean | undefined;
		hasInheritedViewRestrictions: boolean | undefined;
		isSpaceRestricted: boolean | undefined;
		loading: boolean;
	}) => JSX.Element | null;
	contentId: string;
	spaceKey: string;
};

export const RestrictionsCheck = ({ children, spaceKey }: RestrictionsCheckProps) => (
	<SpaceRestrictionCheck asSuperAdmin={false} spaceKey={spaceKey}>
		{({
			error: spaceRestrictionCheckError,
			isSpaceRestricted,
			loading: spaceRestrictionCheckIsLoading,
		}) => (
			<PageViewRestrictions>
				{({
					error: pageViewRestrictionsError,
					hasDirectViewRestrictions,
					hasInheritedViewRestrictions,
					loading: pageViewRestrictionsIsLoading,
				}) =>
					children({
						error: spaceRestrictionCheckError || pageViewRestrictionsError,
						hasDirectViewRestrictions,
						hasInheritedViewRestrictions,
						isSpaceRestricted,
						loading: spaceRestrictionCheckIsLoading || pageViewRestrictionsIsLoading || false,
					})
				}
			</PageViewRestrictions>
		)}
	</SpaceRestrictionCheck>
);
